export default function Logo({ size = "md", subtitle = false, className = "" }) {
  const sizes = {
    sm: "text-base tracking-[0.32em]",
    md: "text-xl tracking-[0.38em]",
    lg: "text-3xl sm:text-4xl tracking-[0.42em]",
    xl: "text-4xl sm:text-5xl lg:text-6xl tracking-[0.44em]",
  };
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="synergy-logo">
      <div
        className={`font-serif font-medium text-[#C9A84C] uppercase ${sizes[size]} leading-tight`}
      >
        The Synergy Table
      </div>
      {subtitle && (
        <div className="mt-3 text-xs uppercase tracking-[0.4em] text-[#9A9590]/80 font-light">
          Where the right people close the right deals.
        </div>
      )}
    </div>
  );
}
